export const API_URL = 'https://wedays-edenred-2024-api-azd7av2vva-ew.a.run.app/'

//export const API_URL = 'https://nardo-dev-portatile-api.plesh.co/'